/**
 * @file Embedded Form
 */

/**
 * Embedded Form component
 */
const vEmbeddedForm = () => {
	const embeddedForm = document.querySelector('.v-embedded-form');

	if (!embeddedForm || embeddedForm.getAttribute('data-form-type') !== 'blackbaud') {
		return;
	}

	if (wpPostData.externalForm) {
		/* eslint-disable */
		window.bboxInit = function () {
			bbox.showForm(wpPostData.externalForm);
		};
		(function () {
			const e = document.createElement('script');
			e.async = true;
			e.src   = 'https://bbox.blackbaudhosting.com/webforms/bbox-min.js';
			document.getElementsByTagName('head')[0].appendChild(e);
		}());
	}
	/* eslint-enable */

	/**
	 * Removes any added styles from the external form
	 */
	const removeAddedStyles = () => {
		const addedStyles = document.querySelectorAll('link[rel="stylesheet"][href^="https://bbox.blackbaudhosting.com"]');
		[...addedStyles].forEach( (style) => {
			style.parentNode.removeChild(style);
		} );
	};

	/**
	 * Unhides the designation section
	 */
	const unhideDesignation = () => {
		const designation = document.querySelector('#bboxdonation_designation_divSection');

		if (!designation || !designation.hasAttribute('style')) {
			return;
		}

		designation.removeAttribute('style');
	};

	/**
	 * Wrap add <select> element w/ div.v-BBFormSelectList__wrap
	 *
	 * @return {null} return nothing
	 */
	 function wrapSelects() {
		const selects = document.querySelectorAll( '.BBFormSelectList' );
		const arrows  = document.querySelectorAll( '.v-BBFormSelectList__arrow' );

		if ( ! selects || arrows.length ) {
			return;
		}

		[ ...selects ].forEach( ( el ) => {
			const wrapper = document.createElement( 'div' );
			const arrow   = document.createElement( 'div' );
			wrapper.classList.add( 'v-BBFormSelectList__wrap' );
			arrow.classList.add( 'v-BBFormSelectList__arrow' );

			if ( ! el.parentNode.classList.contains( 'BBCCreditType' ) ) {
				el.parentNode.insertBefore( wrapper, el );
				wrapper.appendChild( el );
				el.insertAdjacentElement( 'afterEnd', arrow );
			}
		} );

		return null;
	}

	/**
	 * Wrap <input type="checkbox"> element w/ div.v-checkbox
	 */
	 function wrapCheckboxes() {
		const checkboxes = document.querySelectorAll( 'input[type="checkbox"]' );

		if ( ! checkboxes ) {
			return;
		}

		[ ...checkboxes ].forEach( ( input ) => {
			// make sure checkboxes arent already styled
			if ( ! input.classList.contains( 'v-checkbox-loaded' ) ) {
				// create element
				const styledCheckbox = document.createElement( 'span' );
				// add class for custom checkbox styles
				styledCheckbox.classList.add( 'v-checkbox' );
				// insert newly created element
				input.insertAdjacentElement( 'afterend', styledCheckbox );
				// add class to input
				input.classList.add( 'v-checkbox-loaded' );
			}
		} );
	};

	/**
	 * Wrap recurrence labels in their own spans.
	 */
	const wrapRecurrenceLabels = () => {
		const recurrence = document.querySelector( '.BBRecurrenceFieldContainer span' );

		if ( ! recurrence ) {
			return;
		}

		if ( ! recurrence.classList.contains( 'v-BBRecurrenceFieldContainer' ) ) {
			const children  = recurrence.childNodes;

			[ ...children ].forEach( ( n ) => {
				if ( n.nodeType === Node.TEXT_NODE ) {
					const labelWrap = document.createElement( 'span' );
					labelWrap.classList.add( 'v-BBRecurrenceFieldContainer__text-label' );
					recurrence.insertBefore( labelWrap, n );
					labelWrap.appendChild( n );
				}
			} );

			recurrence.classList.add( 'v-BBRecurrenceFieldContainer' );
		}
	}

	/**
	 * Style the submit button
	 */
	const styleSubmitButton = () => {
		const submitButton = document.querySelector( '#bboxdonation_btnSubmit' );

		if ( ! submitButton ) {
			return;
		}

		submitButton.classList.add( 'v-button' );
		submitButton.value = 'Submit';
	};

	/**
	 * Calls any modifications to be done on the external form
	 */
	const init = () => {
		unhideDesignation();
		wrapSelects();
		wrapCheckboxes();
		wrapRecurrenceLabels();
		styleSubmitButton();
	};

	/* const styles = document.querySelectorAll('link[rel="stylesheet"][href^="https://bbox.blackbaudhosting.com"]');
	for (let i = 0; i < styles.length; i++) {
		styles[i].parentNode.removeChild(styles[i]);
	} */

	removeAddedStyles();

	const targetNode = document.querySelector('head');
	const config     = {
		childList: true,
	};

	/**
	 * Mutation observer callback to remove stylesheets added by BBOX
	 *
	 * @param {Array} mutationsList An array of MutatioRecords objects.
	 * @param {Object} observer The observer object that triggered the callback.
	 */
	const callback   = (mutationsList, observer) => {
		removeAddedStyles();
		const addedStyles = document.querySelectorAll('link[rel="stylesheet"][href^="https://bbox.blackbaudhosting.com"]');

		if (addedStyles.length) {
			observer.disconnect();
		}
	};
	const observer   = new MutationObserver(callback);
	observer.observe(targetNode, config);

	// listen for form fully loaded
	const donationForm = document.querySelector('#bbox-root');
	// let prevChecked    = null;

	if (donationForm) {
		const formConfig   = {
			childList: true,
		};

		/**
		 * Mutation observer callback to run when form is loaded
		 */
		const donateFormCb = () => {
			const field = donationForm.querySelector('input');
			if (field) {
				init();
				// console.log('form loaded');
			}
		};
		const formObserver = new MutationObserver(donateFormCb);
		formObserver.observe(donationForm, formConfig);
	}

	/**
	 * Set up donation submit event
	 */
		const donationEventSetup = () => {
		const eventForm     = document.querySelector( '#bbox-root' );
		const eventConfig   = {
			childList: true,
		};
		const eventCb       = function( mutationsList, o ) {
			const eventConfirmation   = eventForm.querySelector( '#bboxdonation_divThanks' );
			if ( ! eventConfirmation ) {
				return;
			}
			const confirmationDetails = eventConfirmation.querySelector( '.BBFormConfirmationTransactionDetails' );
			const value               = confirmationDetails.innerText.match( /\$.*/ )[ 0 ]?.replace( '$', '' ).replace( ',', '' );
			if ( dataLayer ) {
				try {
					dataLayer.push( { event: 'donation-submitted', conversionValue: parseFloat( value ) } );
					console.log( 'donation-submitted', parseFloat( value ) );
				} catch {
					console.error( 'Donation amount could not be parsed.' );
				}
			}
			o.disconnect();
		};
		const eventObserver = new MutationObserver( eventCb );
		eventObserver.observe( eventForm, eventConfig );
	};
	donationEventSetup();
};

export default vEmbeddedForm;
